<template>
  <li class="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
    <div class="w-0 flex-1 flex items-center">
      <paper-clip-icon class="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
      <span class="ml-2 flex-1 w-0 truncate">{{ fullDescription }}</span>
    </div>
    <div class="ml-4 flex-shrink-0">
      <a :href="downloadLink" class="font-medium text-indigo-600 hover:text-indigo-500">
        Descargar
      </a>
    </div>
  </li>
</template>

<script>
import PaperClipIcon from "../PaperClipIcon";
export default {
  name: "DescriptionAdjuntoItem",
  components: {PaperClipIcon},
  props: {
    fileName: {
      type: String,
      required: true,
    },
    downloadLink: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: '',
    },
  },

  computed: {
    fullDescription(){
      return this.fileName + ' ' + this.description;
    },
  },
}
</script>

<style scoped>

</style>